export enum SideModals {
  ADDCREDIT = 'addCredit',
  BILLING_ADJUSTS = 'billingAdjusts',
  CANCELLATION_ORDERS = 'cancellationOrders',
  CHARGE_HISTORY = 'chargeHistory',
  FILTERS = 'filters',
  FREIGHT_CALCULATOR = 'freightCalculator',
  FREIGHT_CALCULATOR_TABLE = 'freightCalculatorTable',
  GENERATE_FILES = 'generateFiles',
  GENERATE_ROMANEIO = 'generateRomaneio',
  OWN_CONTRACT_CORREIOS = 'ownContractCorreios',
  DETAILS_SHIPMENT_SIMULATE = 'simulatePrePaid',
  DETAILS_SHIPMENT_PRINT = 'printFiles',
  DETAILS_SHIPMENT_QUOTATION = 'quotation',
  DETAILS_SHIPMENT_CANCELLATION_ORDER = 'cancellationOrder',
  WELCOME_GO_PLUS = 'welcomeGoPlus',
  WELCOME_FIRST_SHIPMENT = 'welcomeFirstShipment',
  GENERATE_FILES_FROM_ORDERS = 'generateFilesFromOrders',
  MISSING_FISCAL_DOCUMENT_INFORMATION = 'missingFiscalDocumentInformation',
  IFOOD_TRACKING = 'ifoodTracking'
}

export enum Banners {
  GOPLUS = 'show-go-plus-banner',
  JADLOG = 'show-jadlog-activation-banner',
  WELCOME_PROMOTION = 'welcomeCreditPromotionBanner',
  LOGGI = 'showLoggiActivationBanner'
}

export enum DisplaySwitches {
  HIDE_SAME_DAY_ONBOARDING_MODAL = 'hideSameDayOnboardingModal'
}

export enum CorreiosContract {
  NE = 'NE',
  OWN_CONTRACT = 'Proprio'
}

export enum DateQueryFormat {
  StartCreatedAt = 'yyyy-MM-01',
  EndCreatedAt = 'yyyy-MM-dd',
  Current = 'yyyy-MM'
}
